export default function UnauthController($location, $scope, $rootScope) {
	var self = this;
	$rootScope.showSideMenu = false;
	setTimeout(function(){
		$("#unauth-img").addClass("slide-right-image");
	}, 200);
}


/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-unauth/UnauthController.js
 **/